import { create } from 'zustand'
import { featureFlagsSlice, type FeatureFlagsState } from './featureFlagsSlice'

/**
 * The server-evaluated feature flags (see `featureFlagsSlice`). A store of its own: reading a flag
 * is a leaf concern and must not pull the app store, with all its slices, into every component.
 */
export const useFeatureFlagsStore = create<FeatureFlagsState>()(featureFlagsSlice)
